import React, { useState, useEffect, useRef } from "react";
import { ThemeCtx, ToastCtx, api, SEV_C, STAT_C, PAGE_SIZE, Pager, Card, Modal, Bdg, Dot, Av, AdminBadge, useToast, ConfirmDialog, usePagination } from "../shared.js";

export function PageIntegrations({myVulns,refreshVulns}){
  var T=React.useContext(ThemeCtx).T;
  var PURPLE="#A100FF";
  var _tab=useState("connectors"); var tab=_tab[0]; var setTab=_tab[1];
  var _feeds=useState([]); var feeds=_feeds[0]; var setFeeds=_feeds[1];
  var _feedsLoading=useState(false); var feedsLoading=_feedsLoading[0]; var setFeedsLoading=_feedsLoading[1];
  var _feedsLoaded=useState(false); var feedsLoaded=_feedsLoaded[0]; var setFeedsLoaded=_feedsLoaded[1];
  var _newFeedUrl=useState(""); var newFeedUrl=_newFeedUrl[0]; var setNewFeedUrl=_newFeedUrl[1];
  var _newFeedName=useState(""); var newFeedName=_newFeedName[0]; var setNewFeedName=_newFeedName[1];
  var _customFeeds=useState([]); var customFeeds=_customFeeds[0]; var setCustomFeeds=_customFeeds[1];


  var _sel=useState(null); var sel=_sel[0]; var setSel=_sel[1];
  var _search=useState(""); var search=_search[0]; var setSearch=_search[1];
  var _cat=useState("All"); var cat=_cat[0]; var setCat=_cat[1];
  var _syncStatus=useState({}); var syncStatus=_syncStatus[0]; var setSyncStatus=_syncStatus[1];
  var _uploading=useState(false); var uploading=_uploading[0]; var setUploading=_uploading[1];
  var _uploadResult=useState(null); var uploadResult=_uploadResult[0]; var setUploadResult=_uploadResult[1];
  var _fileContent=useState(""); var fileContent=_fileContent[0]; var setFileContent=_fileContent[1];
  var _fileName=useState(""); var fileName=_fileName[0]; var setFileName=_fileName[1];
  var _aiText=useState(""); var aiText=_aiText[0]; var setAiText=_aiText[1];
  var _aiParsing=useState(false); var aiParsing=_aiParsing[0]; var setAiParsing=_aiParsing[1];
  var _aiFindings=useState([]); var aiFindings=_aiFindings[0]; var setAiFindings=_aiFindings[1];
  var _aiImporting=useState(false); var aiImporting=_aiImporting[0]; var setAiImporting=_aiImporting[1];
  var _aiResult=useState(null); var aiResult=_aiResult[0]; var setAiResult=_aiResult[1];
  var _aiError=useState(""); var aiError=_aiError[0]; var setAiError=_aiError[1];
  var _liveForm=useState({url:"",username:"",password:"",api_key:"",api_secret:"",module:"both"});
  var liveForm=_liveForm[0]; var setLiveForm=_liveForm[1];
  var setLF=function(k,v){setLiveForm(function(p){return Object.assign({},p,{[k]:v});});};
  var _liveSyncing=useState(false); var liveSyncing=_liveSyncing[0]; var setLiveSyncing=_liveSyncing[1];
  var _liveResult=useState(null); var liveResult=_liveResult[0]; var setLiveResult=_liveResult[1];
  var _kevList=useState([]); var kevList=_kevList[0]; var setKevList=_kevList[1];
  var _kevSearch=useState(""); var kevSearch=_kevSearch[0]; var setKevSearch=_kevSearch[1];
  var _kevLoading=useState(false); var kevLoading=_kevLoading[0]; var setKevLoading=_kevLoading[1];

  var QUALYS_PLATFORMS=[
    ["https://qualysapi.qg1.apps.qualys.in","India Platform 1 (qg1.in)"],
    ["https://qualysapi.qualys.com","US Platform 1"],
    ["https://qualysapi.qg2.apps.qualys.com","US Platform 2 (qg2)"],
    ["https://qualysapi.qg3.apps.qualys.com","US Platform 3 (qg3)"],
    ["https://qualysapi.qualys.eu","EU Platform 1"],
    ["https://qualysapi.qg2.apps.qualys.eu","EU Platform 2 (qg2.eu)"],
  ];

  var TOOLS=[
    {id:"qualys",     name:"Qualys VMDR",     cat:"Infrastructure", live:true,  fileFormats:["xml","csv"],
     desc:"Sync findings from Qualys Vulnerability Management. Supports VMDR + WAS live sync.",usePlatform:true,useModule:true,useUserPass:true},
    {id:"tenable",    name:"Tenable.io",      cat:"Infrastructure", live:true,  fileFormats:["json"],
     desc:"Sync vulnerability findings from Tenable.io cloud platform.",useUrl:true,useApiKey:true,useApiSecret:true},
    {id:"nessus",     name:"Nessus",          cat:"Infrastructure", live:false, fileFormats:["xml"],
     desc:"Import .nessus scan files from Nessus Professional or Essentials."},
    {id:"rapid7",     name:"Rapid7 InsightVM",cat:"Infrastructure", live:false, fileFormats:["json","csv"],
     desc:"Import scan data from Rapid7 InsightVM."},
    {id:"openvas",    name:"OpenVAS / GVM",   cat:"Infrastructure", live:false, fileFormats:["xml"],
     desc:"Import open-source vulnerability scan results from OpenVAS."},
    {id:"crowdstrike",name:"CrowdStrike",     cat:"Infrastructure", live:false, fileFormats:["json"],
     desc:"Import endpoint vulnerability findings from CrowdStrike Falcon."},
    {id:"fortify",    name:"Fortify",         cat:"SAST",           live:false, fileFormats:["xml","fvdl"],
     desc:"Import SAST findings from Micro Focus Fortify (FVDL format)."},
    {id:"checkmarx",  name:"Checkmarx",       cat:"SAST",           live:false, fileFormats:["xml"],
     desc:"Import SAST scan results from Checkmarx One or CxSAST."},
    {id:"veracode",   name:"Veracode",        cat:"SAST",           live:false, fileFormats:["xml"],
     desc:"Import static analysis results from Veracode platform."},
    {id:"sonarqube",  name:"SonarQube",       cat:"SAST",           live:false, fileFormats:["json"],
     desc:"Import code quality and security findings from SonarQube."},
    {id:"semgrep",    name:"Semgrep / SARIF", cat:"SAST",           live:false, fileFormats:["json","sarif"],
     desc:"Import SAST findings from Semgrep or any SARIF-compatible tool."},
    {id:"burpsuite",  name:"Burp Suite",      cat:"DAST",           live:false, fileFormats:["xml"],
     desc:"Import web application scan results from Burp Suite Enterprise."},
    {id:"owaspzap",   name:"OWASP ZAP",       cat:"DAST",           live:false, fileFormats:["json"],
     desc:"Import dynamic scan results from OWASP ZAP."},
    {id:"qualys_was", name:"Qualys WAS",      cat:"DAST",           live:true,  fileFormats:["xml"],
     desc:"Sync web application scan findings from Qualys WAS.",usePlatform:true,useUserPass:true},
    {id:"snyk",       name:"Snyk",            cat:"SCA",            live:false, fileFormats:["json"],
     desc:"Import dependency and code vulnerabilities from Snyk."},
    {id:"dependabot", name:"Dependabot",      cat:"SCA",            live:false, fileFormats:["json"],
     desc:"Import GitHub Dependabot security alerts."},
    {id:"trivy",      name:"Trivy",           cat:"Container",      live:false, fileFormats:["json"],
     desc:"Import container and IaC vulnerability findings from Trivy."},
    {id:"prismacloud",name:"Prisma Cloud",    cat:"Container",      live:false, fileFormats:["json"],
     desc:"Import cloud-native security findings from Palo Alto Prisma."},
    {id:"aws_sh",     name:"AWS Security Hub",cat:"Cloud",          live:false, fileFormats:["json"],
     desc:"Import cloud vulnerability findings from AWS Security Hub."},
    {id:"azure_def",  name:"Azure Defender",  cat:"Cloud",          live:false, fileFormats:["json"],
     desc:"Sync findings from Microsoft Defender for Cloud."},
    {id:"wiz",        name:"Wiz",             cat:"Cloud",          live:false, fileFormats:["json"],
     desc:"Import cloud security posture findings from Wiz."},
  ];

  var cats=["All","Infrastructure","SAST","DAST","SCA","Container","Cloud"];
  var catColors={Infrastructure:"#3B82F6",SAST:"#8B5CF6",DAST:"#EC4899",SCA:"#22C55E",
    Container:"#06B6D4",Cloud:"#22C55E"};

  useEffect(function(){
    api.get("/integrations/sync-status").then(function(d){
      var map={};(d||[]).forEach(function(s){map[s.tool]=s;});setSyncStatus(map);
    }).catch(function(){});
  },[]);
  useEffect(function(){
    if(tab==="threats"&&!feedsLoaded&&!feedsLoading){
      setFeedsLoading(true);
      api.get("/threat-feeds").then(function(d){setFeeds(d||[]);setFeedsLoaded(true);setFeedsLoading(false);}).catch(function(){setFeedsLoading(false);});
      api.get("/threat-feeds/config").then(function(d){setCustomFeeds(d||[]);}).catch(function(){});
    }
  },[tab,feedsLoaded]);

  useEffect(function(){
    if(tab==="kev"&&kevList.length===0){
      setKevLoading(true);
      api.get("/integrations/kev-catalogue").then(function(d){
        setKevList(d||[]);setKevLoading(false);
      }).catch(function(){setKevLoading(false);});
    }
  },[tab]);

  var filtered=TOOLS.filter(function(t){
    if(cat!=="All"&&t.cat!==cat) return false;
    if(search&&!(t.name+t.desc+t.cat).toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  var liveTools=TOOLS.filter(function(t){return t.live;});
  var inp=function(){return{width:"100%",padding:"8px 10px",background:T.inset,border:"1px solid "+T.border,borderRadius:6,color:T.text,fontSize:12,outline:"none"};};

  var handleFile=function(e){
    var file=e.target.files[0];if(!file)return;
    setFileName(file.name);
    var reader=new FileReader();
    reader.onload=function(ev){setFileContent(ev.target.result);};
    reader.readAsText(file);
  };

  var doAiExtract=async function(){
    if(!aiText.trim()){setAiError("Please paste some text first");return;}
    setAiParsing(true);setAiFindings([]);setAiError("");setAiResult(null);
    try{
      var prompt="Extract all vulnerability findings from the following text. "+
        "Return ONLY a JSON array with no markdown, no explanation. "+
        "Each object must have: cve (string, use QID-xxx or FINDING-N if no CVE), "+
        "title (string), asset (string, hostname or IP), "+
        "severity (one of: Critical/High/Medium/Low), "+
        "description (string, brief), cvss (number 0-10, 0 if unknown). "+
        "If no vulnerabilities found return empty array [].\n\nTEXT:\n"+aiText.slice(0,8000);
      var r=await api.post("/agent/chat",{messages:[{role:"user",content:prompt}]});
      var reply=r.reply||"";
      // Extract JSON from response
      var jsonMatch=reply.match(/\[[\s\S]*\]/);
      if(!jsonMatch) throw new Error("AI did not return valid JSON. Try with more structured text.");
      var parsed=JSON.parse(jsonMatch[0]);
      if(!Array.isArray(parsed)||parsed.length===0){
        setAiError("No vulnerabilities found in the text. Try pasting a scan report, pentest findings, or security email.");
        setAiParsing(false);return;
      }
      // Get next VUL ID sequence from server
      var nextNum=1;
      try{var vlist=await api.get("/vulns");nextNum=(vlist.length||0)+1;}catch(e){void e;}
      // Normalize
      var findings=parsed.map(function(f,i){return{
        id:"VUL-"+String(nextNum+i).padStart(3,"0"),
        cve:f.cve||"",
        title:f.title||"Unknown finding",
        asset:f.asset||"unknown",
        severity:(["Critical","High","Medium","Low"].includes(f.severity)?f.severity:"Medium"),
        description:f.description||"",
        cvss:parseFloat(f.cvss)||0,
        selected:true,
      };});
      setAiFindings(findings);
    }catch(e){setAiError("AI extraction failed: "+e.message);}
    setAiParsing(false);
  };

  var doAiImport=async function(){
    var selected=aiFindings.filter(function(f){return f.selected;});
    if(!selected.length){setAiError("Select at least one finding to import");return;}
    setAiImporting(true);setAiResult(null);setAiError("");
    try{
      var r=await api.post("/integrations/upload/file",{
        content:JSON.stringify(selected.map(function(f){return{
          cve:f.cve,title:f.title,asset:f.asset,severity:f.severity,
          description:f.description,cvss:f.cvss,
          tool:"ai_import",scanner_name:"AI Import",scan_type:"manual"
        };})),
        filename:"ai-import.json",
        tool:"json"
      });
      setAiResult(r);
      setAiFindings([]);setAiText("");
    }catch(e){setAiError("Import failed: "+e.message);}
    setAiImporting(false);
  };

  var toggleAiFinding=function(id){
    setAiFindings(function(p){return p.map(function(f){return f.id===id?Object.assign({},f,{selected:!f.selected}):f;});});
  };

  var doUpload=async function(toolId){
    if(!fileContent){alert("Please select a file first");return;}
    setUploading(true);setUploadResult(null);
    try{
      var r=await api.post("/integrations/upload/file",{content:fileContent,filename:fileName,tool:toolId||""});
      setUploadResult(r);setFileContent("");setFileName("");
      if(r.imported>0 && refreshVulns) refreshVulns();
    }catch(e){setUploadResult({error:e.message});}
    setUploading(false);
  };

  var doLiveSync=async function(t){
    setLiveSyncing(true);setLiveResult(null);
    try{
      var endpoint,payload;
      if(t.id==="tenable"){
        endpoint="/integrations/tenable/sync";
        payload={url:liveForm.url||"https://cloud.tenable.com",api_key:liveForm.api_key,api_secret:liveForm.api_secret};
      } else {
        endpoint="/integrations/qualys/sync";
        payload={url:liveForm.url||QUALYS_PLATFORMS[0][0],username:liveForm.username,password:liveForm.password,module:liveForm.module||"both"};
      }
      var r=await api.post(endpoint,payload);
      // Tenable returns jobId (async) — poll until done
      if(r.jobId){
        setLiveResult({status:"running",message:"Tenable sync running... checking every 15s"});
        var maxTries=40, tries=0;
        var poll=async function(){
          tries++;
          var job=await api.get("/integrations/tenable/job/"+r.jobId).catch(function(){return null;});
          if(!job){setLiveResult({error:"Could not reach job status"});setLiveSyncing(false);return;}
          if(job.status==="done"){
            setLiveResult(job);
            if(job.imported>0&&refreshVulns) refreshVulns();
            api.get("/integrations/sync-status").then(function(d){var map={};(d||[]).forEach(function(s){map[s.tool]=s;});setSyncStatus(map);}).catch(function(){});
            setLiveSyncing(false);
          } else if(job.status==="error"){
            setLiveResult({error:job.error||"Tenable sync failed"});
            setLiveSyncing(false);
          } else if(tries<maxTries){
            setLiveResult({status:"running",message:"Tenable sync running... attempt "+tries+" of "+maxTries});
            setTimeout(poll,15000);
          } else {
            setLiveResult({error:"Tenable sync timed out — check server logs"});
            setLiveSyncing(false);
          }
        };
        setTimeout(poll,15000);
        return;
      }
      // Qualys — direct response
      setLiveResult(r);
      if(r.imported>0 && refreshVulns) refreshVulns();
      api.get("/integrations/sync-status").then(function(d){var map={};(d||[]).forEach(function(s){map[s.tool]=s;});setSyncStatus(map);}).catch(function(){});
    }catch(e){setLiveResult({error:e.message});}
    setLiveSyncing(false);
  };

  var _tp=null;
  if(tab==="threats"){
    var _tm=feeds.reduce(function(s,f){return s+f.items.filter(function(i){return i.inAvta&&i.inAvta.length>0;}).length;},0);
    _tp=React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:16}},
      React.createElement("div",{style:{display:"flex",gap:10,flexWrap:"wrap"}},
        React.createElement("div",{style:{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:8,padding:"10px 16px",flex:1,minWidth:140}},
          React.createElement("div",{style:{fontSize:20,fontWeight:700,color:"#ef4444"}},_tm),
          React.createElement("div",{style:{fontSize:11,color:"#991b1b",marginTop:2}},"Matches in your environment")),
        React.createElement("div",{style:{background:"#f0fdf4",border:"1px solid #bbf7d0",borderRadius:8,padding:"10px 16px",flex:1,minWidth:140}},
          React.createElement("div",{style:{fontSize:20,fontWeight:700,color:"#16a34a"}},feeds.filter(function(f){return f.ok;}).length+"/"+feeds.length),
          React.createElement("div",{style:{fontSize:11,color:"#166534",marginTop:2}},"Feeds online")),
        React.createElement("div",{style:{background:"#eff6ff",border:"1px solid #bfdbfe",borderRadius:8,padding:"10px 16px",flex:1,minWidth:140}},
          React.createElement("div",{style:{fontSize:20,fontWeight:700,color:"#2563eb"}},feeds.reduce(function(s,f){return s+f.items.length;},0)),
          React.createElement("div",{style:{fontSize:11,color:"#1e40af",marginTop:2}},"Total advisories fetched")),
        React.createElement("button",{onClick:function(){setFeedsLoaded(false);setFeedsLoading(false);setFeeds([]);},
          style:{padding:"8px 14px",background:"#A100FF",color:"#fff",border:"none",borderRadius:6,cursor:"pointer",fontSize:12,fontWeight:600,alignSelf:"center"}},
          feedsLoading?"Refreshing...":"Refresh Feeds")
      ),
      feedsLoading&&React.createElement("div",{style:{textAlign:"center",padding:40,color:"#A100FF",fontSize:13}},"Fetching threat feeds..."),
      !feedsLoading&&feeds.length===0&&React.createElement("div",{style:{textAlign:"center",padding:40,color:"#94a3b8",fontSize:12}},"Click Refresh Feeds to load threat intelligence"),
      !feedsLoading&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:10}},
        feeds.map(function(feed,fi){
          var matchItems=feed.items.filter(function(i){return i.inAvta&&i.inAvta.length>0;});
          return React.createElement("div",{key:fi,style:{border:"1px solid #e5e7eb",borderRadius:10,overflow:"hidden",background:"#fff"}},
            React.createElement("div",{style:{background:feed.ok?"#0f0a1a":"#fef2f2",padding:"10px 16px",display:"flex",alignItems:"center",justifyContent:"space-between"}},
              React.createElement("div",{style:{display:"flex",alignItems:"center",gap:10}},
                React.createElement("span",{style:{fontSize:14,fontWeight:700,color:feed.ok?"#fff":"#ef4444"}},feed.name),
                feed.ok
                  ? React.createElement("span",{style:{background:"#22c55e",color:"#fff",fontSize:9,fontWeight:700,padding:"2px 7px",borderRadius:10}},"LIVE")
                  : React.createElement("span",{style:{background:"#ef4444",color:"#fff",fontSize:9,fontWeight:700,padding:"2px 7px",borderRadius:10}},"ERROR")
              ),
              React.createElement("div",{style:{display:"flex",gap:8,alignItems:"center"}},
                matchItems.length>0&&React.createElement("span",{style:{background:"#ef4444",color:"#fff",fontSize:10,fontWeight:700,padding:"3px 9px",borderRadius:10}},matchItems.length+" in your env"),
                React.createElement("span",{style:{fontSize:10,color:feed.ok?"rgba(255,255,255,0.5)":"#ef4444"}},feed.items.length+" items")
              )
            ),
            !feed.ok&&React.createElement("div",{style:{padding:"10px 16px",fontSize:12,color:"#ef4444"}},"Error: "+feed.error),
            feed.ok&&React.createElement("div",{style:{maxHeight:300,overflowY:"auto"}},
              feed.items.map(function(item,ii){
                var hasMatch=item.inAvta&&item.inAvta.length>0;
                return React.createElement("div",{key:ii,style:{padding:"10px 16px",borderBottom:"1px solid #f3f4f6",background:hasMatch?"#fff7ed":"transparent",display:"flex",flexDirection:"column",gap:4}},
                  React.createElement("div",{style:{display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:8}},
                    React.createElement("a",{href:item.link||"#",target:"_blank",rel:"noopener noreferrer",
                      style:{fontSize:12,fontWeight:600,color:hasMatch?"#ea580c":"#1d4ed8",textDecoration:"none",flex:1,lineHeight:1.4}},item.title||"Untitled"),
                    item.pubDate&&React.createElement("span",{style:{fontSize:10,color:"#94a3b8",flexShrink:0,whiteSpace:"nowrap"}},new Date(item.pubDate).toLocaleDateString())
                  ),
                  React.createElement("div",{style:{display:"flex",gap:6,flexWrap:"wrap",alignItems:"center"}},
                    hasMatch&&React.createElement("span",{style:{background:"#ef4444",color:"#fff",fontSize:9,fontWeight:700,padding:"2px 7px",borderRadius:10,letterSpacing:.5}},"IN YOUR ENV"),
                    item.cves.slice(0,6).map(function(cve){
                      var inAvta=item.inAvta&&item.inAvta.includes(cve);
                      return React.createElement("span",{key:cve,style:{background:inAvta?"#fef2f2":"#f1f5f9",color:inAvta?"#dc2626":"#64748b",border:"1px solid "+(inAvta?"#fecaca":"#e2e8f0"),fontSize:9,fontWeight:600,padding:"1px 6px",borderRadius:4}},cve);
                    }),
                    item.cves.length>6&&React.createElement("span",{style:{fontSize:9,color:"#94a3b8"}},"+"+(item.cves.length-6)+" more CVEs")
                  )
                );
              })
            )
          );
        })
      ),
      React.createElement("div",{style:{border:"1px solid #e5e7eb",borderRadius:10,padding:"14px 16px",background:"#fafafa"}},
        React.createElement("div",{style:{fontSize:12,fontWeight:700,color:"#374151",marginBottom:10}},"Add Custom RSS Feed"),
        React.createElement("div",{style:{display:"flex",gap:8,flexWrap:"wrap"}},
          React.createElement("input",{value:newFeedName,onChange:function(e){setNewFeedName(e.target.value);},placeholder:"Feed name",
            style:{padding:"6px 10px",fontSize:12,border:"1px solid #d1d5db",borderRadius:6,width:160,fontFamily:"inherit"}}),
          React.createElement("input",{value:newFeedUrl,onChange:function(e){setNewFeedUrl(e.target.value);},placeholder:"https://example.com/feed.xml",
            style:{padding:"6px 10px",fontSize:12,border:"1px solid #d1d5db",borderRadius:6,flex:1,minWidth:200,fontFamily:"inherit"}}),
          React.createElement("button",{
            onClick:function(){
              if(!newFeedUrl||!newFeedName)return;
              var updated=[...customFeeds,{name:newFeedName,url:newFeedUrl,type:"custom"}];
              api.put("/threat-feeds/config",{feeds:updated}).then(function(){
                setCustomFeeds(updated);setNewFeedUrl("");setNewFeedName("");setFeedsLoaded(false);
              }).catch(function(e){alert("Error: "+e.message);});
            },
            style:{padding:"6px 14px",background:"#A100FF",color:"#fff",border:"none",borderRadius:6,cursor:"pointer",fontSize:12,fontWeight:600}},"Add Feed")
        ),
        customFeeds.length>0&&React.createElement("div",{style:{marginTop:10,display:"flex",flexDirection:"column",gap:4}},
          customFeeds.map(function(f,i){
            return React.createElement("div",{key:i,style:{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"5px 8px",background:"#fff",border:"1px solid #e5e7eb",borderRadius:6}},
              React.createElement("span",{style:{fontSize:11,color:"#374151"}},f.name+" - "+f.url),
              React.createElement("button",{onClick:function(){
                var updated=customFeeds.filter(function(_,j){return j!==i;});
                api.put("/threat-feeds/config",{feeds:updated}).then(function(){setCustomFeeds(updated);setFeedsLoaded(false);}).catch(function(){});
              },style:{background:"none",border:"none",color:"#ef4444",cursor:"pointer",fontSize:12,fontWeight:700}},"x")
            );
          })
        )
      )
    );
  }
  return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:12}},
    // Tabs
    React.createElement("div",{style:{display:"flex",borderBottom:"1px solid "+T.border,gap:0,marginBottom:4}},
      [["connectors","🔗 Connectors"],["live","⚡ Live Sync"],["upload","↑ File Upload"],["ai","🤖 AI Import"],["stats","📊 Scanner Stats"],["kev","🛡 CISA KEV"],["threats","🚨 Threat Feeds"]].map(function(t){
        return React.createElement("button",{key:t[0],onClick:function(){setTab(t[0]);setSel(null);},
          style:{padding:"10px 18px",background:"transparent",border:"none",
            borderBottom:tab===t[0]?"2px solid "+PURPLE:"2px solid transparent",
            color:tab===t[0]?PURPLE:T.text3,cursor:"pointer",fontSize:12,
            fontWeight:tab===t[0]?700:400,whiteSpace:"nowrap"}},t[1]);
      })
    ),

    // CONNECTORS
    tab==="connectors"&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:10}},
      React.createElement("div",{style:{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}},
        React.createElement("input",{placeholder:"Search...",value:search,
          onChange:function(e){setSearch(e.target.value);},
          style:{padding:"7px 10px",background:T.inset,border:"1px solid "+T.border,
            color:T.text,fontSize:12,outline:"none",flex:"1 1 160px",borderRadius:6}}),
        cats.map(function(ct){
          return React.createElement("button",{key:ct,onClick:function(){setCat(ct);},
            style:{padding:"5px 12px",background:cat===ct?PURPLE:T.inset,
              color:cat===ct?"#fff":T.text3,border:"1px solid "+(cat===ct?PURPLE:T.border),
              cursor:"pointer",fontSize:11,fontWeight:cat===ct?700:400,borderRadius:4}},ct);
        }),
        React.createElement("div",{style:{fontSize:12,color:T.text3}},filtered.length+" tools")
      ),
      React.createElement("div",{style:{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:10}},
        filtered.map(function(t){
          var cc=catColors[t.cat]||PURPLE;
          var ss=syncStatus[t.id];
          return React.createElement("div",{key:t.id,
            style:{background:T.card,border:"1px solid "+T.border,borderRadius:10,padding:"14px 16px",
              borderTop:"3px solid "+(t.live?"#22c55e":cc)}},
            React.createElement("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:6}},
              React.createElement("div",null,
                React.createElement("div",{style:{fontSize:13,fontWeight:700,color:T.text,marginBottom:2}},t.name),
                React.createElement("span",{style:{background:cc+"18",color:cc,border:"1px solid "+cc+"33",
                  padding:"1px 7px",fontSize:10,fontWeight:600,borderRadius:4}},t.cat)
              ),
              t.live&&React.createElement("span",{style:{background:"#22c55e18",color:"#22c55e",
                border:"1px solid #22c55e33",padding:"1px 7px",fontSize:9,fontWeight:700,borderRadius:4}},
                "⚡ Live")
            ),
            React.createElement("div",{style:{fontSize:11,color:T.text2,lineHeight:1.5,marginBottom:8}},t.desc),
            ss&&ss.last_status==="OK"&&React.createElement("div",{style:{fontSize:10,color:"#22c55e",marginBottom:6}},
              "✓ "+new Date(ss.last_sync).toLocaleDateString()+" · "+ss.last_count+" findings"),
            React.createElement("div",{style:{display:"flex",gap:6}},
              t.live&&React.createElement("button",{
                onClick:function(){setTab("live");setSel(t);setLiveResult(null);
                  if(t.usePlatform) setLF("url",QUALYS_PLATFORMS[0][0]);},
                style:{flex:1,padding:"6px",background:"#22c55e",color:"#fff",border:"none",
                  borderRadius:6,cursor:"pointer",fontSize:11,fontWeight:700}},
                "⚡ Live Sync"),
              t.fileFormats&&t.fileFormats.length>0&&React.createElement("button",{
                onClick:function(){setTab("upload");setSel(t);setUploadResult(null);setFileContent("");setFileName("");},
                style:{flex:t.live?0:1,padding:"6px",background:t.live?T.inset:PURPLE,
                  color:t.live?T.text2:"#fff",border:"1px solid "+(t.live?T.border:PURPLE),
                  borderRadius:6,cursor:"pointer",fontSize:11,fontWeight:600,minWidth:t.live?70:0}},
                "Upload")
            )
          );
        })
      )
    ),

    // LIVE SYNC
    tab==="live"&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:10}},
      React.createElement("div",{style:{background:"#22c55e18",border:"1px solid #22c55e44",borderRadius:8,
        padding:"10px 14px",fontSize:12,color:"#22c55e",marginBottom:4}},
        "⚡ Live sync connects directly to scanner APIs — no manual export needed. Credentials are used only for the request and not stored."),
      liveTools.map(function(t){
        var isSelected=sel&&sel.id===t.id;
        var ss=syncStatus[t.id];
        return React.createElement("div",{key:t.id,
          style:{background:T.card,border:"2px solid "+(isSelected?"#22c55e":T.border),borderRadius:10,overflow:"hidden"}},
          React.createElement("div",{onClick:function(){setSel(isSelected?null:t);setLiveResult(null);
            if(t.usePlatform) setLF("url",QUALYS_PLATFORMS[0][0]);},
            style:{padding:"14px 16px",display:"flex",alignItems:"center",
              justifyContent:"space-between",cursor:"pointer",
              background:isSelected?"#22c55e0C":"transparent"}},
            React.createElement("div",{style:{display:"flex",alignItems:"center",gap:10}},
              React.createElement(Icon,{name:"Link2",size:20}),
              React.createElement("div",null,
                React.createElement("div",{style:{fontSize:13,fontWeight:700,color:T.text}},t.name),
                React.createElement("div",{style:{fontSize:11,color:T.text3}},t.desc))
            ),
            React.createElement("div",{style:{display:"flex",alignItems:"center",gap:8}},
              ss&&React.createElement("span",{style:{fontSize:11,fontWeight:600,padding:"3px 10px",borderRadius:20,
                background:ss.last_status==="OK"?"#2ea04322":"#e5534b22",
                color:ss.last_status==="OK"?"#2ea043":"#e5534b"}},
                ss.last_status==="OK"
                  ?"Last: "+new Date(ss.last_sync).toLocaleDateString()+" ("+ss.last_count+")"
                  :ss.last_status==="never"?"Never synced":"Error"),
              React.createElement("span",{style:{color:T.text3,fontSize:16}},isSelected?"▲":"▼")
            )
          ),
          isSelected&&React.createElement("div",{style:{padding:"16px",borderTop:"1px solid "+T.border}},
            React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:12}},
              t.usePlatform&&React.createElement("div",null,
                React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text2,marginBottom:4}},"Platform"),
                React.createElement("select",{value:liveForm.url||QUALYS_PLATFORMS[0][0],
                  onChange:function(e){setLF("url",e.target.value);},style:inp()},
                  QUALYS_PLATFORMS.map(function(p){return React.createElement("option",{key:p[0],value:p[0]},p[1]);}))),
              t.useUrl&&React.createElement("div",null,
                React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text2,marginBottom:4}},"API URL"),
                React.createElement("input",{value:liveForm.url,placeholder:"https://cloud.tenable.com",
                  onChange:function(e){setLF("url",e.target.value);},style:inp()})),
              t.useModule&&React.createElement("div",null,
                React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text2,marginBottom:4}},"Module"),
                React.createElement("select",{value:liveForm.module||"both",
                  onChange:function(e){setLF("module",e.target.value);},style:inp()},
                  React.createElement("option",{value:"both"},"VMDR + WAS (both)"),
                  React.createElement("option",{value:"vmdr"},"VMDR only"),
                  React.createElement("option",{value:"was"},"WAS only"))),
              t.useUserPass&&React.createElement("div",null,
                React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text2,marginBottom:4}},"Username"),
                React.createElement("input",{value:liveForm.username,autoComplete:"off",
                  onChange:function(e){setLF("username",e.target.value);},style:inp()})),
              t.useUserPass&&React.createElement("div",null,
                React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text2,marginBottom:4}},"Password"),
                React.createElement("input",{type:"password",value:liveForm.password,autoComplete:"new-password",
                  onChange:function(e){setLF("password",e.target.value);},style:inp()})),
              t.useApiKey&&React.createElement("div",null,
                React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text2,marginBottom:4}},"API Access Key"),
                React.createElement("input",{value:liveForm.api_key,
                  onChange:function(e){setLF("api_key",e.target.value);},style:inp()})),
              t.useApiSecret&&React.createElement("div",null,
                React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text2,marginBottom:4}},"API Secret Key"),
                React.createElement("input",{type:"password",value:liveForm.api_secret,
                  onChange:function(e){setLF("api_secret",e.target.value);},style:inp()}))
            ),
            React.createElement("div",{style:{display:"flex",alignItems:"center",gap:10}},
              React.createElement("button",{onClick:function(){doLiveSync(t);},disabled:liveSyncing,
                style:{background:"#22c55e",color:"#fff",border:"none",borderRadius:8,
                  padding:"9px 20px",cursor:"pointer",fontSize:12,fontWeight:600,
                  opacity:liveSyncing?0.6:1}},liveSyncing?"⏳ Syncing...":"⚡ Sync Now"),
              React.createElement("div",{style:{fontSize:11,color:T.text3}},
                "Credentials used only for this request — not stored")
            ),
            liveResult&&React.createElement("div",{style:{marginTop:12,padding:"10px 14px",borderRadius:8,
              background:liveResult.error?"#e5534b18":"#2ea04318",
              border:"1px solid "+(liveResult.error?"#e5534b44":"#2ea04344")}},
              liveResult.error
                ? React.createElement("span",{style:{color:"#e5534b",fontSize:12}},"❌ "+liveResult.error)
                : React.createElement("div",{style:{fontSize:12,color:"#2ea043"}},
                    "✅ ",React.createElement("strong",null,liveResult.imported)," imported, ",
                    liveResult.skipped," skipped of ",liveResult.total," total",
                    liveResult.errors&&liveResult.errors.length>0&&
                      React.createElement("div",{style:{marginTop:4,fontSize:11,color:"#e8892b"}},
                        "⚠ "+liveResult.errors.join("; ")))
            )
          )
        );
      })
    ),

    // AI IMPORT
    tab==="ai"&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:12}},
      React.createElement("div",{style:{background:"#A100FF18",border:"1px solid #A100FF44",borderRadius:8,
        padding:"12px 16px",fontSize:12,color:T.text2,lineHeight:1.6}},
        React.createElement("strong",{style:{color:"#A100FF"}},"🤖 AI-Powered Import — "),
        "Paste any text containing vulnerability information — pentest reports, security emails, Jira tickets, "+
        "raw scan output, or meeting notes. Claude will extract and structure the findings for import."
      ),
      // Text input
      React.createElement("div",null,
        React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text2,marginBottom:6}},
          "Paste text containing vulnerability findings"),
        React.createElement("textarea",{
          value:aiText,
          onChange:function(e){setAiText(e.target.value);setAiError("");setAiFindings([]);setAiResult(null);},
          placeholder:"Paste raw text with vulnerabilities — pentest report, email, scan output, Jira ticket...",
          rows:10,
          style:{width:"100%",padding:"12px",background:T.inset,border:"1px solid "+T.border,
            borderRadius:8,color:T.text,fontSize:12,outline:"none",resize:"vertical",
            fontFamily:"monospace",lineHeight:1.6}
        })
      ),
      React.createElement("div",{style:{display:"flex",gap:10,alignItems:"center"}},
        React.createElement("button",{onClick:doAiExtract,disabled:aiParsing||!aiText.trim(),
          style:{background:"#A100FF",color:"#fff",border:"none",borderRadius:8,
            padding:"10px 20px",cursor:"pointer",fontSize:13,fontWeight:700,
            opacity:(aiParsing||!aiText.trim())?0.5:1,display:"flex",alignItems:"center",gap:6}},
          React.createElement(Icon,{name:"Bot",size:15}),
          aiParsing?"Extracting...":"Extract Findings"),
        aiText.trim()&&React.createElement("div",{style:{fontSize:11,color:T.text3}},
          aiText.trim().split(" ").length+" words · "+aiText.length+" chars")
      ),
      aiError&&React.createElement("div",{style:{background:"#e5534b18",border:"1px solid #e5534b44",
        borderRadius:8,padding:"10px 14px",fontSize:12,color:"#e5534b"}},
        React.createElement(Icon,{name:"AlertCircle",size:13,style:{display:"inline",marginRight:6}}),
        aiError
      ),
      // Preview table
      aiFindings.length>0&&React.createElement("div",{style:{background:T.card,borderRadius:10,
        border:"1px solid "+T.border,overflow:"hidden"}},
        React.createElement("div",{style:{padding:"12px 16px",borderBottom:"1px solid "+T.border,
          display:"flex",alignItems:"center",justifyContent:"space-between"}},
          React.createElement("div",{style:{fontSize:13,fontWeight:700,color:T.text}},
            "🎯 "+aiFindings.length+" findings extracted — review before importing"),
          React.createElement("div",{style:{display:"flex",gap:8}},
            React.createElement("button",{onClick:function(){setAiFindings(function(p){return p.map(function(f){return Object.assign({},f,{selected:true});});});},
              style:{fontSize:11,padding:"4px 10px",background:T.inset,color:T.text2,
                border:"1px solid "+T.border,borderRadius:6,cursor:"pointer"}},"Select All"),
            React.createElement("button",{onClick:function(){setAiFindings(function(p){return p.map(function(f){return Object.assign({},f,{selected:false});});});},
              style:{fontSize:11,padding:"4px 10px",background:T.inset,color:T.text2,
                border:"1px solid "+T.border,borderRadius:6,cursor:"pointer"}},"Deselect All")
          )
        ),
        React.createElement("div",{style:{overflowX:"auto"}},
          React.createElement("table",{style:{width:"100%",borderCollapse:"collapse",fontSize:12}},
            React.createElement("thead",null,
              React.createElement("tr",null,
                ["","CVE","Title","Asset","Severity","CVSS","Description"].map(function(h){
                  return React.createElement("th",{key:h,style:{padding:"8px 12px",textAlign:"left",
                    fontSize:10,fontWeight:700,color:T.text3,textTransform:"uppercase",
                    letterSpacing:.7,background:T.inset,borderBottom:"1px solid "+T.border,
                    whiteSpace:"nowrap"}},h);
                })
              )
            ),
            React.createElement("tbody",null,
              aiFindings.map(function(f,i){
                var sevC={Critical:"#dc2626",High:"#ea580c",Medium:"#ca8a04",Low:"#16a34a"};
                return React.createElement("tr",{key:f.id,
                  style:{background:f.selected?(i%2===0?T.card:T.inset):"#64748b08",
                    opacity:f.selected?1:0.5}},
                  React.createElement("td",{style:{padding:"8px 12px",borderBottom:"1px solid "+T.border}},
                    React.createElement("input",{type:"checkbox",checked:f.selected,
                      onChange:function(){toggleAiFinding(f.id);},
                      style:{width:14,height:14,accentColor:"#A100FF"}})),
                  React.createElement("td",{style:{padding:"8px 12px",borderBottom:"1px solid "+T.border,
                    fontWeight:600,color:T.accent,whiteSpace:"nowrap",fontSize:11}},f.cve),
                  React.createElement("td",{style:{padding:"8px 12px",borderBottom:"1px solid "+T.border,
                    maxWidth:180,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}},f.title),
                  React.createElement("td",{style:{padding:"8px 12px",borderBottom:"1px solid "+T.border,
                    fontSize:11,color:T.text2,whiteSpace:"nowrap"}},f.asset),
                  React.createElement("td",{style:{padding:"8px 12px",borderBottom:"1px solid "+T.border}},
                    React.createElement("span",{style:{background:(sevC[f.severity]||"#64748b")+"18",
                      color:sevC[f.severity]||"#64748b",border:"1px solid "+(sevC[f.severity]||"#64748b")+"33",
                      padding:"2px 8px",borderRadius:4,fontSize:10,fontWeight:700}},f.severity)),
                  React.createElement("td",{style:{padding:"8px 12px",borderBottom:"1px solid "+T.border,
                    fontSize:11,color:T.text3}},f.cvss||"—"),
                  React.createElement("td",{style:{padding:"8px 12px",borderBottom:"1px solid "+T.border,
                    fontSize:11,color:T.text2,maxWidth:200,overflow:"hidden",
                    textOverflow:"ellipsis",whiteSpace:"nowrap"}},f.description||"—")
                );
              })
            )
          )
        ),
        React.createElement("div",{style:{padding:"12px 16px",borderTop:"1px solid "+T.border,
          display:"flex",alignItems:"center",gap:10}},
          React.createElement("button",{onClick:doAiImport,
            disabled:aiImporting||aiFindings.filter(function(f){return f.selected;}).length===0,
            style:{background:"#22c55e",color:"#fff",border:"none",borderRadius:8,
              padding:"9px 20px",cursor:"pointer",fontSize:13,fontWeight:700,
              opacity:aiImporting?0.6:1,display:"flex",alignItems:"center",gap:6}},
            React.createElement(Icon,{name:"Upload",size:14}),
            aiImporting?"Importing...":
              "Import "+aiFindings.filter(function(f){return f.selected;}).length+" findings"),
          React.createElement("div",{style:{fontSize:11,color:T.text3}},
            "Findings will be deduplicated against existing records")
        )
      ),
      aiResult&&React.createElement("div",{style:{padding:"12px 16px",borderRadius:8,
        background:aiResult.error?"#e5534b18":"#2ea04318",
        border:"1px solid "+(aiResult.error?"#e5534b44":"#2ea04344")}},
        aiResult.error
          ? React.createElement("span",{style:{color:"#e5534b",fontSize:13}},
              React.createElement(Icon,{name:"X",size:13,style:{display:"inline",marginRight:6}}),
              aiResult.error)
          : React.createElement("div",{style:{fontSize:13,color:"#2ea043"}},
              React.createElement(Icon,{name:"Check",size:13,style:{display:"inline",marginRight:6}}),
              React.createElement("strong",null,aiResult.imported)," findings imported, ",
              aiResult.skipped," duplicates skipped of ",aiResult.total," total")
      )
    ),

    // FILE UPLOAD
    tab==="upload"&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:10}},
      React.createElement("div",{style:{background:T.inset,border:"1px solid "+T.border,borderRadius:8,
        padding:"10px 14px",fontSize:12,color:T.text2,marginBottom:4}},
        "↑ Upload scan reports exported from your security tools. Formats: XML, JSON, CSV, SARIF, .nessus — auto-detected."),
      React.createElement("div",{style:{background:T.card,border:"2px dashed "+T.border,borderRadius:10,
        padding:"30px",textAlign:"center"}},
        React.createElement("div",{style:{fontSize:36,marginBottom:8}},React.createElement(Icon,{name:"FileText",size:36})),
        React.createElement("div",{style:{fontSize:14,fontWeight:600,color:T.text,marginBottom:4}},
          sel?"Upload "+sel.name+" findings":"Select a scan file to import"),
        React.createElement("div",{style:{fontSize:12,color:T.text3,marginBottom:16}},
          sel&&sel.fileFormats?"Supported: "+sel.fileFormats.join(", ").toUpperCase()
            :"All formats: XML · JSON · CSV · SARIF · .nessus · .fvdl"),
        React.createElement("input",{type:"file",id:"fileInput2",
          accept:".xml,.json,.csv,.sarif,.nessus,.fvdl",
          onChange:handleFile,style:{display:"none"}}),
        React.createElement("label",{htmlFor:"fileInput2",
          style:{background:PURPLE,color:"#fff",padding:"10px 24px",borderRadius:8,
            cursor:"pointer",fontSize:13,fontWeight:600,display:"inline-block"}},
          "Choose File"),
        fileName&&React.createElement("div",{style:{fontSize:12,color:T.text2,marginTop:10}},
          "Selected: ",React.createElement("strong",null,fileName))
      ),
      React.createElement("div",null,
        React.createElement("div",{style:{fontSize:11,fontWeight:600,color:T.text2,marginBottom:6}},
          "Scanner (leave blank for auto-detect)"),
        React.createElement("select",{value:sel?sel.id:"",
          onChange:function(e){var t=TOOLS.find(function(x){return x.id===e.target.value;});setSel(t||null);},
          style:{width:"100%",padding:"8px 10px",background:T.inset,border:"1px solid "+T.border,
            borderRadius:6,color:T.text,fontSize:12,outline:"none"}},
          React.createElement("option",{value:""},"Auto-detect from file content"),
          TOOLS.filter(function(t){return t.fileFormats&&t.fileFormats.length>0;}).map(function(t){
            return React.createElement("option",{key:t.id,value:t.id},t.name+" ("+t.fileFormats.join(", ")+")");
          })
        )
      ),
      React.createElement("button",{onClick:function(){doUpload(sel?sel.id:"");},
        disabled:uploading||!fileContent,
        style:{background:PURPLE,color:"#fff",border:"none",borderRadius:8,padding:"10px 20px",
          cursor:"pointer",fontSize:13,fontWeight:600,opacity:(uploading||!fileContent)?0.5:1}},
        uploading?"⏳ Uploading...":"↑ Import Findings"),
      uploadResult&&React.createElement("div",{style:{padding:"12px 16px",borderRadius:8,
        background:uploadResult.error?"#e5534b18":"#2ea04318",
        border:"1px solid "+(uploadResult.error?"#e5534b44":"#2ea04344")}},
        uploadResult.error
          ? React.createElement("span",{style:{color:"#e5534b",fontSize:13}},"❌ "+uploadResult.error)
          : React.createElement("div",{style:{fontSize:13,color:"#2ea043"}},
              "✅ ",React.createElement("strong",null,uploadResult.imported)," imported, ",
              uploadResult.skipped," duplicates skipped of ",uploadResult.total," total",
              uploadResult.tool_detected&&React.createElement("div",{style:{fontSize:11,color:T.text3,marginTop:4}},
                "Detected: "+uploadResult.tool_detected))
      )
    ),

    // SCANNER STATS
    tab==="stats"&&React.createElement(PageSourceTools,{myVulns:myVulns||[]}),

    tab==="kev"&&React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:12}},
      (function(){
        var allKev=(myVulns||[]).filter(function(v){return v.kev;});
        var kevOpen=allKev.filter(function(v){return v.status!=="Remediated"&&v.status!=="Exception";});
        var kevOverdue=kevOpen.filter(function(v){return v.days_left<0;});
        var kevRem=allKev.filter(function(v){return v.status==="Remediated";});
        var kevCves=new Set(kevOpen.map(function(v){return v.cve;}));
        return React.createElement("div",{style:{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:10}},
          [{l:"KEV CVEs in env",v:kevCves.size,c:"#DC2626",sub:"of "+kevList.length+" total CISA KEV"},
           {l:"Open KEV vulns",v:kevOpen.length,c:PURPLE,sub:"need immediate action"},
           {l:"Overdue KEV",v:kevOverdue.length,c:"#ef4444",sub:"SLA breached"},
           {l:"KEV Remediated",v:kevRem.length,c:"#22c55e",sub:"cleared from env"},
          ].map(function(s){
            return React.createElement("div",{key:s.l,
              style:{background:T.card,border:"1px solid "+T.border,borderRadius:10,padding:"12px 14px"}},
              React.createElement("div",{style:{fontSize:22,fontWeight:800,color:s.c}},s.v),
              React.createElement("div",{style:{fontSize:12,color:T.text,marginTop:2,fontWeight:600}},s.l),
              React.createElement("div",{style:{fontSize:10,color:T.text3,marginTop:1}},s.sub)
            );
          })
        );
      })(),
      React.createElement("div",{style:{display:"flex",gap:8,alignItems:"center"}},
        React.createElement("input",{placeholder:"Search CVE ID, vendor, product...",value:kevSearch,
          onChange:function(e){setKevSearch(e.target.value);},
          style:{flex:1,padding:"8px 12px",background:T.inset,border:"1px solid "+T.border,
            borderRadius:6,color:T.text,fontSize:12,outline:"none"}}),
        React.createElement("span",{style:{fontSize:12,color:T.text3,whiteSpace:"nowrap"}},
          (function(){
            var inEnv=new Set((myVulns||[]).filter(function(v){return v.kev&&v.cve;}).map(function(v){return v.cve;}));
            var cnt=kevList.filter(function(k){
              if(!inEnv.has(k.cveID)) return false;
              if(!kevSearch) return true;
              return (k.cveID+k.vendorProject+k.product+k.vulnerabilityName).toLowerCase().includes(kevSearch.toLowerCase());
            }).length;
            return cnt+" in your env of "+kevList.length+" total KEV";
          })()),
        React.createElement("button",{
          onClick:function(){
            setKevLoading(true);
            api.get("/integrations/kev-catalogue?refresh=1").then(function(d){
              setKevList(d||[]);setKevLoading(false);
            }).catch(function(){setKevLoading(false);});
          },
          style:{padding:"7px 14px",background:T.inset,color:T.text2,border:"1px solid "+T.border,
            borderRadius:6,cursor:"pointer",fontSize:11,fontWeight:600,whiteSpace:"nowrap",
            display:"flex",alignItems:"center",gap:4}},
          React.createElement(Icon,{name:"RefreshCw",size:12})," Refresh")
      ),
      React.createElement("div",{style:{background:T.card,borderRadius:10,overflow:"hidden",border:"1px solid "+T.border}},
        React.createElement("table",{style:{width:"100%",borderCollapse:"collapse"}},
          React.createElement("thead",null,
            React.createElement("tr",null,
              ["CVE ID","Vendor","Product","Vulnerability","Due Date","In AVTA"].map(function(h){
                return React.createElement("th",{key:h,style:{padding:"10px 12px",textAlign:"left",
                  fontSize:10,fontWeight:700,color:T.text3,textTransform:"uppercase",
                  letterSpacing:.8,background:T.inset,borderBottom:"1px solid "+T.border,
                  whiteSpace:"nowrap"}},h);
              })
            )
          ),
          React.createElement("tbody",null,
            kevLoading
              ? React.createElement("tr",null,React.createElement("td",{colSpan:6,
                  style:{padding:40,textAlign:"center",color:T.text3}},"Loading KEV catalogue..."))
              : (function(){
                  var kevCveMap={};
                  (myVulns||[]).filter(function(v){return v.kev&&v.cve;}).forEach(function(v){
                    if(!kevCveMap[v.cve])kevCveMap[v.cve]={count:0,overdue:false,maxSev:"Low",statuses:[]};
                    kevCveMap[v.cve].count++;
                    if(v.days_left<0&&v.status!=="Remediated"&&v.status!=="Exception")kevCveMap[v.cve].overdue=true;
                    var sr={Critical:0,High:1,Medium:2,Low:3};
                    if((sr[v.severity]||3)<(sr[kevCveMap[v.cve].maxSev]||3))kevCveMap[v.cve].maxSev=v.severity;
                    if(!kevCveMap[v.cve].statuses.includes(v.status))kevCveMap[v.cve].statuses.push(v.status);
                  });
                  var inAvta=new Set(Object.keys(kevCveMap));
                  var rows=kevList.filter(function(k){
                    if(!inAvta.has(k.cveID)) return false;
                    if(!kevSearch) return true;
                    return (k.cveID+k.vendorProject+k.product+k.vulnerabilityName).toLowerCase().includes(kevSearch.toLowerCase());
                  }).slice(0,300);
                  if(!rows.length) return React.createElement("tr",null,
                    React.createElement("td",{colSpan:6,style:{padding:30,textAlign:"center",color:T.text3}},
                      kevList.length?(kevSearch?"No matching KEV CVEs in your environment":"✓ No CISA KEV CVEs found in your environment — great news!"):"Click Refresh to load KEV catalogue"));
                  return rows.map(function(k,i){
                    var found=inAvta.has(k.cveID);
                    return React.createElement("tr",{key:k.cveID,
                      style:{background:found?"#DC262608":i%2===0?T.card:T.inset}},
                      React.createElement("td",{style:{padding:"8px 12px",fontSize:11,fontWeight:700,
                        color:found?"#DC2626":T.accent,borderBottom:"1px solid "+T.border}},
                        React.createElement("a",{href:"https://nvd.nist.gov/vuln/detail/"+k.cveID,
                          target:"_blank",rel:"noopener noreferrer",
                          style:{color:"inherit",textDecoration:"none"}},k.cveID)),
                      React.createElement("td",{style:{padding:"8px 12px",fontSize:11,color:T.text2,borderBottom:"1px solid "+T.border}},k.vendorProject||"—"),
                      React.createElement("td",{style:{padding:"8px 12px",fontSize:11,color:T.text2,borderBottom:"1px solid "+T.border}},k.product||"—"),
                      React.createElement("td",{style:{padding:"8px 12px",fontSize:11,color:T.text,borderBottom:"1px solid "+T.border,maxWidth:220,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}},k.vulnerabilityName||"—"),
                      React.createElement("td",{style:{padding:"8px 12px",fontSize:11,color:T.text3,borderBottom:"1px solid "+T.border,whiteSpace:"nowrap"}},k.dueDate||"—"),
                      React.createElement("td",{style:{padding:"8px 12px",borderBottom:"1px solid "+T.border}},
                        React.createElement("div",{style:{display:"flex",gap:4,flexWrap:"wrap"}},
                          React.createElement("span",{style:{background:"#DC262618",color:"#DC2626",
                            border:"1px solid #DC262633",padding:"2px 8px",borderRadius:4,fontSize:10,fontWeight:700}},
                            (kevCveMap[k.cveID]&&kevCveMap[k.cveID].count||0)+" vuln"+(kevCveMap[k.cveID]&&kevCveMap[k.cveID].count!==1?"s":"")),
                          kevCveMap[k.cveID]&&kevCveMap[k.cveID].overdue
                            ? React.createElement("span",{style:{background:"#ef444418",color:"#ef4444",
                                border:"1px solid #ef444433",padding:"2px 6px",borderRadius:4,fontSize:10,fontWeight:700}},"OVERDUE")
                            : React.createElement("span",{style:{background:"#22c55e18",color:"#22c55e",
                                border:"1px solid #22c55e33",padding:"2px 6px",borderRadius:4,fontSize:10}},
                                (kevCveMap[k.cveID]&&kevCveMap[k.cveID].maxSev)||"Low")
                        )
                      )
                    );
                  });
                })()
          )
        )
      )
    ),
    _tp
  );
}
